// extracted by mini-css-extract-plugin
export default {"formLayout":"AoItSWtL3N51COgGrxCN"};